import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { setToken, getToken, removeToken } from '@/utils/auth'
import { getSession, removeSession } from "@/utils/session";
import router from '@/router'

import { logout } from '@/api/app'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 1000 * 30
})

service.interceptors.request.use(
  config => {
    const token = store.state.app.token
    if (token) {
      config.headers.Authorization = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)


service.interceptors.response.use(
  response => {
    const res = response
   
    if (res.status === 200) {
      if (res.data.code == 200) {
        return res.data
      } else if (res.data.code == 500) {
        logoutHandler()
        Message.error(res.data.msg)
        return Promise.reject(res.data)
      } else {
        // console.log(123567,res.data);
        let filename = res.headers['content-disposition'].split('filename=')[1];
        if (res.data instanceof Blob) {
         
          return { filename: filename, data: res.data }
        } else {
          Message.error(res.data.msg)
          return Promise.reject(res.data)
        }

      }
    } else {
      // console.log('response s~:', res)
      Message.error(res.message)
      return Promise.reject(res.message)
    }
  },
  error => {
    // console.log('response error:', res)
    logoutHandler()
    // Message.error(error)
    return Promise.reject(error)
  }
)

function logoutHandler() {
  logout({ userName: getSession("userInfo").userName })
  removeToken();
  removeSession("userInfo");
  store.commit("app/LOGOUT");
  router.push("/login");
}

export default service